import { useEffect, useMemo, useState } from 'react'
import Button from 'src/components/atoms/Button'
import TableImage from 'src/components/atoms/TableImage'
import Page from 'src/components/layouts/Page'
import TableFilterable from 'src/components/organisms/TableFilterable'
import css from './Employees.module.scss'
import EmployeeModal from 'src/components/modals/EmployeeModal'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import NumberFormat from 'react-number-format'
import { deleteEmployee, getEmployees, clearState } from 'src/slices/employee'
import { getLocations } from 'src/slices/info'
import EmptyPage from 'src/components/molecules/EmptyPage'
import { defaultPermissions, handleStatus } from 'src/slices/utils'

export default function Employees(params) {
	const dispatch = useDispatch()
	const { user, currBranch, type: userType } = useSelector(state => state.auth)
	const { locations } = useSelector(state => state.info)
	const { employees } = useSelector(state => state.employee)
	const { status } = useSelector(state => state.employee)

	const [showModal, setShowModal] = useState(false)
	const [employee, setCurrentEmployee] = useState()
	const [type, setType] = useState('create')

	useEffect(() => {
		dispatch(getEmployees())
		dispatch(getLocations())
	}, [])

	useEffect(() => {
		if (locations.length > 0) {
			setCurrentEmployee({
				email: {
					value: '',
				},
				firstName: '',
				lastName: '',
				phone: '',
				branches: [
					{
						_id: currBranch,
						neighborhood: locations.find(branch => branch._id == currBranch)
							.neighborhood,
						isDefault: true,

						permissions: defaultPermissions('employee'),
					},
				],
			})
		}
	}, [locations])

	function handleCreate() {
		setType('create')
		setCurrentEmployee({
			email: {
				value: '',
			},
			firstName: '',
			lastName: '',
			phone: '',
			branches: [
				{
					_id: currBranch,
					neighborhood: locations.find(branch => branch._id == currBranch).neighborhood,
					// isAdmin: false,
					isDefault: true,

					/*
					Default Permissions
					*/
					permissions: defaultPermissions('employee'),
				},
			],
		})

		setShowModal(true)
	}

	function handleEdit(emp) {
		setType('edit')
		setCurrentEmployee(emp)
		setShowModal(true)
	}

	function handleCloseModal() {
		setShowModal(false)
	}
	const handleDelete = employeeId => {
		dispatch(deleteEmployee(employeeId))
	}

	useEffect(() => {
		handleStatus(status.deleteEmployee, () => dispatch(clearState(status.deleteEmployee)))
	}, [status.deleteEmployee])

	const columns = useMemo(
		() => [
			{
				Header: 'Name',
				accessor: 'name',
				// width: 400,
				Cell: props => {
					return (
						<p>
							{props?.cell?.row?.original?.firstName}{' '}
							{props?.cell?.row?.original?.lastName}
						</p>
					)
				},
			},
			{
				Header: 'Phone',
				accessor: 'phone',
				// width: 400,
				Cell: props => {
					return (
						<NumberFormat
							style={{ width: 'max-content', display: 'inline-block' }}
							value={props?.cell?.row?.values?.phone}
							displayType={'text'}
							format='+1 (###) ###-####'
						/>
					)
				},
			},
			{
				Header: 'Email',
				accessor: 'email',
				Cell: props => {
					return <p>{props?.cell?.row?.values?.email?.value}</p>
				},
			},
			{
				// Header: "Actions",
				Header: ' ',
				// accessor: "id",
				Cell: props => (
					<div className={css['table-actions']}>
						{props.cell.row.original?._id != user.id && (
							<Button
								iconLeft='fad fa-user-times'
								color='red'
								variant='secondary'
								action={() => handleDelete(props.cell.row.original?._id)}
							/>
						)}
						<Button
							iconLeft='fad fa-user-edit'
							color='gray'
							variant='secondary'
							action={() => handleEdit(props.cell.row.original)}
						/>
					</div>
				),
			},
		],

		[]
	)

	return (
		<Page>
			{userType == 'merchant' ? (
				<>
					{employees?.length > 0 ? (
						<TableFilterable
							columns={columns}
							data={employees}
							dataName='employee'
							dataNamePlural='employees'
							createFunction={handleCreate}
							itemsSelectable={false}
						/>
					) : (
						<EmptyPage
							title='You don’t have any employees yet'
							text='Tap create in order to add a new team member'
							iconName='fad fa-user-friends'
							button={
								<Button
									label='Create Employee'
									iconLeft='fad fa-plus'
									action={handleCreate}
								/>
							}
						/>
					)}
					{showModal && (
						<EmployeeModal
							closeFunction={handleCloseModal}
							setEmployee={setCurrentEmployee}
							employee={employee}
							type={type}
						/>
					)}
				</>
			) : (
				<EmptyPage
					title='You don’t have permission to view anything on this page'
					text='Ask your employer for access'
					iconName='fad fa-lock'
				/>
			)}
		</Page>
	)
}
